


// $(document).ready(function () {
// // drawer open in add to cart
//     $('.product--add-to-cart-button').on('click',function(){

// let formSubmitted = false;

//         let prodForm = document.querySelector('form[data-type="add-to-cart-form"]');
//           if (prodForm) {
//             prodForm.addEventListener('submit', (event) => {
//             formSubmitted = true;
//         });

//     }
//       setTimeout(() => { 
//         if (formSubmitted) {
//       setTimeout(function () {
//       $('body').addClass('sidebar-move');
//       $('#site-overlay').addClass('active');
//       $('#site-cart').addClass('active').show();
//       },500);
//        }
//         },1000);
//     });
// // end
//   var firstTabList = $('.table_list:first').attr('value');
//   var firstspacetxt = $('.tabel_dimension_list li:first span p.people_space').text();
//   $('.ppl_space, .peplspace_title').text(firstspacetxt);
//     $('.product-variant').each(function() {
//       var $tableSelected = $(this).find('.main_select_tabl .table_selected');
//       var $tableList = $(this).find('.main_select_tabl .tabel_dimension_list');
//       var firstTabList = $tableList.find('li:first').attr('value');
//       $tableSelected.text(firstTabList).on('click', function() {
//         $('.tabel_dimension_list').not($tableList).hide();
//         $(this).addClass('active');
//         $tableList.toggle();
//       });
//     });

//      $(document).on('click', function (event) {
//     var target = $(event.target);
//     if (!target.closest('.table_selected').length && !target.closest('.tabel_dimension_list').length) {
//       $('.tabel_dimension_list').hide();
//       $('.table_selected').removeClass('active');
//     }
//   });
//   $('.table_list').on('click', function () {
//     var clkvar = $(this).attr('value'); 
//    // console.log(clkvar);
//     $(this).siblings('.table_list').removeClass('table_list_select');
//     $(this).addClass('table_list_select');
//     $(this).siblings('.table_list').removeAttr('selected');
//      $(this).attr('selected', 'true');
//     var selectedValue = $(this).attr('value');
//     var selectedtxt = $(this).text();
//    var spacetxt = $(this).find('span p.people_space').text();
//     $('.peplspace_title').text(spacetxt);
//     $('.ppl_space').text(spacetxt);
//     //console.log(spacetxt);
//     //console.log(selectedValue);
//     //console.log(selectedtxt);
//     $(this).closest('.main_select_tabl').find('.table_selected').text(selectedValue);
//     $('.table_selected').removeClass('active');
    
//     // var prod_infovar1 = $('.prod_infovar1 select').val();
//     // var prod_infovar2 = $('.prod_infovar2 select').val();
//     // var prod_infovar3 = $('.prod_infovar3 select').val();
// // alert(prod_infovar2);
//     //var prod_infovar2 = $(this).closest('.main_select_tabl').find('.prod_infovar2 .table_list').text();
//     //var prod_infovar3 = $(this).closest('.main_select_tabl').find('.prod_infovar3 .table_list').text();

//     var matchingOption2 = $(".varopt_1 select option[value='" + selectedValue + "']");
//     if (matchingOption2.length > 0) {
//       $('.product-variant.varopt_1 select.product-variant-container').val(matchingOption2.val()).trigger('change');
//     }
//     $('.main_var_select select').each(function() {
//     $(this).find('.product-variant-value').each(function() {
//         var get_options_val = $(this).attr('value');
//         // clkvar var is assign above
//         if (get_options_val == clkvar ) {
//             $(this).prop("selected", true);
//              console.log('matched= '+get_options_val);
//         }
//     });
// });

//     var itemselect = [];

// $('.cust_opt_area .cust_get_val_pro').each(function(index) {
//     var cust_get_val_pro = $(this).find('.table_list_select').attr('value');
//     itemselect.push(cust_get_val_pro);
//     if (index < itemselect.length - 1) {
//         itemselect.push(' / ');
//     }
// });
// var modifiedValue = itemselect.join(' / ');
// console.log(modifiedValue);
// //  $('.main_prod_infovar .main_var_select').each(function(index) {
// // var mainvar_select = $(this).find('.table_list_select').attr('value');

// // });   

//     // var modifiedValue = selectedValue + ' / ' + prod_infovar2 + ' / ' + prod_infovar3;
//     // console.log(modifiedValue);
//     //var matchingOption = $('.specifications-select option[data-title="' + modifiedValue + '"]');
//     var matchingOption = $(".specifications-select option[data-title='" + modifiedValue + "']");
//     if (matchingOption.length > 0) {
//       $('.specifications-select').val(matchingOption.val()).trigger('change');
//     }
//     $('.tabel_dimension_list').hide();
//   });
    
// function handleChangeEvent() {
//     $('.main_var_select select').on('change', function () {
//         var get_this_val = $(this).val();
//         //console.log(get_this_val);

//         $('.tabel_dimension_list').each(function () {
//             $(this).find('.table_list').each(function () {
//                 var get_options_val2 = $(this).attr('value');
//                 if (get_options_val2 == get_this_val) {
//                     // Store the reference to $(this) in a variable
//                     var $clickedElement = $(this);

//                     setTimeout(function () {
//                         // Use the stored reference to trigger the click
//                         $clickedElement.trigger('click');
//                         console.log('triggered=> ' + get_options_val2);
//                     }, 50);

//                     //console.log('matched=> ' + get_options_val2);

//                     // Unbind the change event after the first match
//                     $('.main_var_select select').off('change');
//                     setTimeout(function () {
//                         // Rebind the change event after a delay
//                         handleChangeEvent();
//                     }, 50);
//                 } else {
//                     console.log('notmatched=> ' + get_options_val2);
//                 }
//             });
//         });
//     });
// }

// // Initial binding of the change event
// handleChangeEvent();


// // Use event delegation to handle clicks on dynamically added elements
// // $(document).on('click', '.tabel_dimension_list .table_list', function () {
// //     // Your click event handling logic here
// //     console.log('Element clicked:', $(this).text());
// //     // Add more logic as needed
// // });




//   var selectedOptionFirst = $('.specifications-select option:first');
//   updateSpecsDisplay(selectedOptionFirst);
//   $('.specifications-select').on('change', function () {
//     var selectedOption = $(this).find('option:selected');
//     updateSpecsDisplay(selectedOption);
//     // commented by Hasan Irshad
//   //$("span.product-main-price-span1--").text(selectedOption.attr('data-price'));
//   //$("span.product-main-price-span1--").attr('data-price',selectedOption.attr('data-price'));
//   $("span.product-main-compare-price-span1").text(selectedOption.attr('data-compprice'));
//   $(".comp_price_discount span.off-text1").text(selectedOption.attr('data-discount'));
//   var newinput = $('input[name="id"]');
//   newinput.val(selectedOption.attr('value'));
//   });
//   function updateSpecsDisplay(option) {
//     $('.selclength').text(option.attr('data-length'));
//     $('.selcwidth').text(option.attr('data-width'));
//     $('.seldepth').text(option.attr('data-depth'));
//     $('.selheight').text(option.attr('data-height'));
//     $('.selectweight').text(option.attr('data-weight'));
//     $('.cont_lft_img img').attr('src', option.attr('data-sizeimg'));
//     $('.inner_popimg img').attr('src', option.attr('data-sizeimg'));
//     $('.specification_var_sku').text(option.attr('data-sku'));
//     $("span.product-main-price-span").text(option.attr('data-price'));
//     //$("span.product-main-price-span1").text(option.attr('data-price'));
//     //$("span.product-main-compare-price-span1").text(option.attr('data-compprice'));
//     $("span.product-main-compare-price-span").text(option.attr('data-compprice'));
//     $(".peplspace_title").text(option.attr('data-person'));
//     $(".ppl_space").text(option.attr('data-person'));
//       // var newinput = $('input[name="id"]');
//       // newinput.val(option.attr('value'));
//       // console.log("newinput", newinput);
//        // Hide .depth_cnt if data-depth is empty or null
//    // ✅ FIX: Ensure .depth_cnt toggles correctly when switching variants
//     // let depthValue = option.attr('data-depth');
//     // if (!depthValue || depthValue.trim() === "" || depthValue === "null" || depthValue === "undefined") {
//     //     $('.depth_cnt').hide();
//     // } else {
//     //     $('.depth_cnt').show();
//     // }
//   }
//     // ✅ Ensure depth visibility updates correctly after first load
// updateSpecsDisplay($('.specifications-select option:selected'));
    
// $('.cont_lft_img img').on('click',function(){
//   $('.hover_show_img').show();
//   $('body').addClass('show_dimention_sizeimg');
// });
  
//   $(".hover_show_img").on("click", function(){
//      $(this).hide();
//     $('body').removeClass('show_dimention_sizeimg');
//   });
// });




$(document).ready(function () {
// drawer open in add to cart
    $('.product--add-to-cart-button').on('click',function(){

        let formSubmitted = false;

        let prodForm = document.querySelector('form[data-type="add-to-cart-form"]');
        if (prodForm) {
            prodForm.addEventListener('submit', (event) => {
                formSubmitted = true;
            });
        }
        setTimeout(() => { 
            if (formSubmitted) {
                setTimeout(function () {
                    $('body').addClass('sidebar-move');
                    $('#site-overlay').addClass('active');
                    $('#site-cart').addClass('active').show();
                },500);
            }
        },1000);
    });
// end
  var firstTabList = $('.table_list:first').attr('value');
  var firstspacetxt = $('.tabel_dimension_list li:first span p.people_space').text();
  $('.ppl_space, .peplspace_title').text(firstspacetxt);
    $('.product-variant').each(function() {
      var $tableSelected = $(this).find('.main_select_tabl .table_selected');
      var $tableList = $(this).find('.main_select_tabl .tabel_dimension_list');
      var firstTabList = $tableList.find('li:first').attr('value');
      $tableSelected.text(firstTabList).on('click', function() {
        $('.tabel_dimension_list').not($tableList).hide();
        $(this).addClass('active');
        $tableList.toggle();
      });
    });

     $(document).on('click', function (event) {
    var target = $(event.target);
    if (!target.closest('.table_selected').length && !target.closest('.tabel_dimension_list').length) {
      $('.tabel_dimension_list').hide();
      $('.table_selected').removeClass('active');
    }
  });
  $('.table_list').on('click', function () {
    var clkvar = $(this).attr('value'); 
    $(this).siblings('.table_list').removeClass('table_list_select');
    $(this).addClass('table_list_select');
    $(this).siblings('.table_list').removeAttr('selected');
    $(this).attr('selected', 'true');
    var selectedValue = $(this).attr('value');
    var selectedtxt = $(this).text();
    var spacetxt = $(this).find('span p.people_space').text();
    $('.peplspace_title').text(spacetxt);
    $('.ppl_space').text(spacetxt);

    $(this).closest('.main_select_tabl').find('.table_selected').text(selectedValue);
    $('.table_selected').removeClass('active');
    
    var matchingOption2 = $(".varopt_1 select option[value='" + selectedValue + "']");
    if (matchingOption2.length > 0) {
      $('.product-variant.varopt_1 select.product-variant-container').val(matchingOption2.val()).trigger('change');
    }
    $('.main_var_select select').each(function() {
        $(this).find('.product-variant-value').each(function() {
            var get_options_val = $(this).attr('value');
            if (get_options_val == clkvar ) {
                $(this).prop("selected", true);
                 console.log('matched= '+get_options_val);
            }
        });
    });

    var itemselect = [];

    $('.cust_opt_area .cust_get_val_pro').each(function(index) {
        var cust_get_val_pro = $(this).find('.table_list_select').attr('value');
        itemselect.push(cust_get_val_pro);
        if (index < itemselect.length - 1) {
            itemselect.push(' / ');
        }
    });
    var modifiedValue = itemselect.join(' / ');
    console.log(modifiedValue);

    var matchingOption = $(".specifications-select option[data-title='" + modifiedValue + "']");
    if (matchingOption.length > 0) {
      $('.specifications-select').val(matchingOption.val()).trigger('change');
    }
    $('.tabel_dimension_list').hide();
    
    setTimeout(updateVisibility, 100); // ✅ Fix for visibility updates
  });
    
function handleChangeEvent() {
    $('.main_var_select select').on('change', function () {
        var get_this_val = $(this).val();

        $('.tabel_dimension_list').each(function () {
            $(this).find('.table_list').each(function () {
                var get_options_val2 = $(this).attr('value');
                if (get_options_val2 == get_this_val) {
                    var $clickedElement = $(this);

                    setTimeout(function () {
                        $clickedElement.trigger('click');
                        console.log('triggered=> ' + get_options_val2);
                    }, 50);

                    $('.main_var_select select').off('change');
                    setTimeout(function () {
                        handleChangeEvent();
                    }, 50);
                } else {
                    console.log('notmatched=> ' + get_options_val2);
                }
            });
        });
    });
}

// Initial binding of the change event
handleChangeEvent();

  var selectedOptionFirst = $('.specifications-select option:first');
  updateSpecsDisplay(selectedOptionFirst);
  $('.specifications-select').on('change', function () {
    var selectedOption = $(this).find('option:selected');
    updateSpecsDisplay(selectedOption);
  });

function updateSpecsDisplay(option) {
    $('.selclength').text(option.attr('data-length'));
    $('.selcwidth').text(option.attr('data-width'));
    $('.seldepth').text(option.attr('data-depth'));
    $('.upholstery_spec_mat').text(option.attr('data-upholstery'));
    $('.selheight').text(option.attr('data-height'));
    $('.selectweight').text(option.attr('data-weight'));
    $('.cont_lft_img img').attr('src', option.attr('data-sizeimg'));
    $('.inner_popimg img').attr('src', option.attr('data-sizeimg'));
    $('.specification_var_sku').text(option.attr('data-sku'));
    $("span.product-main-price-span").text(option.attr('data-price'));
    $("span.product-main-compare-price-span").text(option.attr('data-compprice'));
    $(".peplspace_title").text(option.attr('data-person'));
    $(".ppl_space").text(option.attr('data-person'));

    updateVisibility(); // ✅ Ensure all elements update correctly
}

// ✅ Function to show/hide .depth_cnt, .length_cnt, .width_cnt, .height_cnt based on their values
function updateVisibility() {
    let selectedOption = $('.specifications-select option:selected');
    
    let depthValue = selectedOption.attr('data-depth');
    let lengthValue = selectedOption.attr('data-length');
    let widthValue = selectedOption.attr('data-width');
    let heightValue = selectedOption.attr('data-height');
    let upholsteryValue = selectedOption.attr('data-upholstery');

    let allEmpty = true; // ✅ Track if all values are empty

    // ✅ Depth visibility
    if (!depthValue || depthValue.trim() === "" || depthValue === "null" || depthValue === "undefined") {
        $('.depth_cnt').hide();
    } else {
        $('.depth_cnt').show();
        allEmpty = false;
    }

    // ✅ upholstery visibility
    if (!upholsteryValue || upholsteryValue.trim() === "" || upholsteryValue === "null" || upholsteryValue === "undefined") {
      $('.upholstery_spec_mat').closest('tr').hide();
    } else {
       $('.upholstery_spec_mat').closest('tr').show();
        allEmpty = false;
    }

    // ✅ Length visibility
    if (!lengthValue || lengthValue.trim() === "" || lengthValue === "null" || lengthValue === "undefined") {
        $('.length_cnt').hide();
    } else {
        $('.length_cnt').show();
        allEmpty = false;
    }

    // ✅ Width visibility
    if (!widthValue || widthValue.trim() === "" || widthValue === "null" || widthValue === "undefined") {
        $('.width_cnt').hide();
    } else {
        $('.width_cnt').show();
        allEmpty = false;
    }

    // ✅ Height visibility
    if (!heightValue || heightValue.trim() === "" || heightValue === "null" || heightValue === "undefined") {
        $('.height_cnt').hide();
    } else {
        $('.height_cnt').show();
        allEmpty = false;
    }

    // ✅ If all dimensions are empty, hide .title_dimen, else show it
    if (allEmpty) {
        $('.title_dimen_1').hide();
    } else {
        $('.title_dimen_1').show();
    }
}

// ✅ Ensure all elements update correctly after first load
updateVisibility();

$('.cont_lft_img img').on('click',function(){
  $('.hover_show_img').show();
  $('body').addClass('show_dimention_sizeimg');
});
  
$(".hover_show_img").on("click", function(){
     $(this).hide();
    $('body').removeClass('show_dimention_sizeimg');
  });
});
